import { Butterfly } from "@phosphor-icons/react";
import { integrationProviderRegistry } from "../integration_registry.js";
import { BlueskyConfigEditor, makeZernioChannelComponent } from "../zernio.js";

function BlueskyIcon() {
  return <Butterfly size={20} />;
}

integrationProviderRegistry.register(
  makeZernioChannelComponent({
    platform: "bluesky",
    label: "Bluesky",
    Icon: BlueskyIcon,
    ConfigEditor: BlueskyConfigEditor,
  }),
);
